import {AfterViewInit, Component, EventEmitter, Input, Output, ViewChild} from '@angular/core';
import {appConfig} from '../../../../config/config';
import {RoundOfQuestions} from '../../../models/round-of-questions.interface';
import {PageRequest} from '../../../../shared/models/page-request.interface';
import {MatPaginator, PageEvent} from '@angular/material/paginator';
import {MatSort} from '@angular/material/sort';
import {MatDialog} from '@angular/material/dialog';
import {CreateRoundOfQuestionsComponent} from '../create-round-of-questions/create-round-of-questions.component';
import {GenericDialogComponent} from '../../../../shared/components/generic-dialog/generic-dialog.component';
import {RoundOfQuestionsService} from '../../../services/round-of-questions.service';
import {EditRoundOfQuestionsComponent} from '../edit-round-of-questions/edit-round-of-questions.component';
import {DatePipe} from '@angular/common';
import {Router} from '@angular/router';

@Component({
  selector: 'app-round-of-questions-table',
  templateUrl: './round-of-questions-table.component.html',
  styleUrls: ['./round-of-questions-table.component.scss']
})
export class RoundOfQuestionsTableComponent implements AfterViewInit {

  pageSizes = appConfig.pageSizes;
  displayedColumns: string[] = ['year', 'name', 'launched', 'edit'];

  @Input()
  roundOfQuestions!: RoundOfQuestions[];
  @Input()
  page!: number;
  @Input()
  pageSize = 100;
  @Input()
  totalElements!: number;

  @Output()
  loadRoundOfQuestions: EventEmitter<PageRequest> = new EventEmitter<PageRequest>();
  @Output()
  updateRoundOfQuestionsStatus: EventEmitter<number> = new EventEmitter<number>();

  @ViewChild(MatPaginator)
  paginator!: MatPaginator;

  @ViewChild(MatSort)
  sort!: MatSort;

  constructor(private readonly roundOfQuestionsService: RoundOfQuestionsService,
              private readonly dialog: MatDialog,
              readonly datePipe: DatePipe,
              readonly router: Router) { }

  ngAfterViewInit(): void {
    this.sort.sortChange.subscribe(() => this.onSortChange(this.sort.active, this.sort.direction));
  }

  onSortChange(active: string, direction: string): void {
    this.loadRoundOfQuestions.emit({page: 0, size: this.pageSize, sort: active, direction});
  }

  onPageChange(event: PageEvent): void {
    this.loadRoundOfQuestions.emit({page: event.pageIndex, size: event.pageSize, sort: this.sort.active, direction: this.sort.direction});
  }

  addRoundOfQuestions(copy: boolean = false, roundOfQuestions?: RoundOfQuestions): void {
    const dialogRef = this.dialog.open(
      CreateRoundOfQuestionsComponent,
      {data: {copy, roundOfQuestions}, maxWidth: 1000, width: 'inherit'}
    );

    dialogRef.componentInstance.createEvent.subscribe(() => {
      this.loadRoundOfQuestions.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  editRoundOfQuestions(value: RoundOfQuestions): void {
    const dialogRef = this.dialog.open(EditRoundOfQuestionsComponent, {data: value, maxWidth: 1000, width: 'inherit'});

    dialogRef.componentInstance.editEvent.subscribe(() => {
      this.loadRoundOfQuestions.emit({
        page: this.paginator.pageIndex, size: this.paginator.pageSize, sort: this.sort.active, direction: this.sort.direction
      });
    });
  }

  updateRoundOfQuestions(roundOfQuestions: RoundOfQuestions): void {
    const dialogRef = this.dialog.open(GenericDialogComponent,
      {
        data:
          {
            title: `${roundOfQuestions.status === 'ACTIVE' ? 'Disable' : 'Enable'} Round Of Questions`,
            text: `Are you sure you want to ${roundOfQuestions.status === 'ACTIVE' ? 'deactivate' : 'activate'} the selected item?`
          }
      });
    dialogRef.componentInstance.confirm.subscribe((confirm: boolean) => {
      if (confirm) {
        this.updateRoundOfQuestionsStatus.emit(roundOfQuestions.id);
      }
      dialogRef.close();
    });
  }

}
